import { useStore } from 'vuex';

/**
 * Composable for actions
 * Usage in Composition API:
 * 
 * import { useMutations } from '@/composables/mutations';
 * 
 * export default {
 *   setup() {
 *     const { addToWL, addToWishlistDetailsStore, addToWishlistStore, changeTab, clearCart, clearCartMeta, clearQuote, clearUserDetails, hideDeletePPWarn, hideDeleteProdWarn, loadCart, loadColorBubbles, loggedOut, loggingOut, removeFromQuote, setBreadcrumbDetails, setCanUpdateBreadcrumb, setCartMeta, showDeletePPWarn, showDeleteProdWarn, storeMegaMenu, storeQuote, storeUserDetails, updateDynamicBreadcrumb, updateQuoteQuant } = useMutations();
 *     return { addToWL, addToWishlistDetailsStore, addToWishlistStore, changeTab, clearCart, clearCartMeta, clearQuote, clearUserDetails, hideDeletePPWarn, hideDeleteProdWarn, loadCart, loadColorBubbles, loggedOut, loggingOut, removeFromQuote, setBreadcrumbDetails, setCanUpdateBreadcrumb, setCartMeta, showDeletePPWarn, showDeleteProdWarn, storeMegaMenu, storeQuote, storeUserDetails, updateDynamicBreadcrumb, updateQuoteQuant };
 *   }
 * }
 */
export function useMutations() {
    const store = useStore();

    const addToWL = (value) => {
        store.commit('addToWL', value);
    }
    const addToWishlistDetailsStore = (value) => {
        store.commit('addToWishlistDetailsStore', value);
    }
    const addToWishlistStore = (value) => {
        store.commit('addToWishlistStore', value);
    }
    const changeTab = (value) => {
        store.commit('changeTab', value);
    }
    const clearCart = () => {
        store.commit('clearCart');
    }
    const clearCartMeta = () => {
        store.commit('clearCartMeta');
    }
    const clearQuote = () => {
        store.commit('clearQuote');
    }
    const clearUserDetails = () => {
        store.commit('clearUserDetails');
    }
    const hideDeletePPWarn = () => {
        store.commit('hideDeletePPWarn');
    }
    const hideDeleteProdWarn = () => {
        store.commit('hideDeleteProdWarn');
    }
    const loadCart = () => {
        store.commit('loadCart');
    }
    const loadColorBubbles = () => {
        store.commit('loadColorBubbles');
    }
    const loggedOut = () => {
        store.commit('loggedOut');
    }
    const loggingOut = () => {
        store.commit('loggingOut');
    }
    const removeFromQuote = (value) => {
        store.commit('removeFromQuote', value);
    }
    const setBreadcrumbDetails = (value) => {
        store.commit('setBreadcrumbDetails', value);
    }
    const setCanUpdateBreadcrumb = (value) => {
        store.commit('setCanUpdateBreadcrumb', value);
    }
    const setCartMeta = (value) => {
        store.commit('setCartMeta', value);
    }
    const setLastReferrerRoute = (value) => {
        store.commit('setLastReferrerRoute', value);
    }
    const showDeletePPWarn = (value) => {
        store.commit('showDeletePPWarn', value);
    }
    const showDeleteProdWarn = (value) => {
        store.commit('showDeleteProdWarn', value);
    }
    const storeMegaMenu = (value) => {
        store.commit('storeMegaMenu', value);
    }
    const storeQuote = (value) => {
        store.commit('storeQuote', value);
    }
    const storeUserDetails = (value) => {
        store.commit('storeUserDetails', value);
    }
    const updateDynamicBreadcrumb = (value) => {
        store.commit('updateDynamicBreadcrumb', value);
    }
    const updateQuoteQuant = (value) => {
        store.commit('updateQuoteQuant', value);
    }
    return {
        addToWL,
        addToWishlistDetailsStore,
        addToWishlistStore,
        changeTab,
        clearCart,
        clearCartMeta,
        clearQuote,
        clearUserDetails,
        hideDeletePPWarn,
        hideDeleteProdWarn,
        loadCart,
        loadColorBubbles,
        loggedOut,
        loggingOut,
        removeFromQuote,
        setBreadcrumbDetails,
        setCanUpdateBreadcrumb,
        setCartMeta,
        setLastReferrerRoute,
        showDeletePPWarn,
        showDeleteProdWarn,
        storeMegaMenu,
        storeQuote,
        storeUserDetails,
        updateDynamicBreadcrumb,
        updateQuoteQuant
    };
}